var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sider-bar",on:{"click":_vm.collapseToggle}},[_c('core-sidebar-menus',{attrs:{"menuCollpased":_vm.menuCollpased,"menus":_vm.menus,"menuTitle":_vm.menuTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }